import { MemberRoleEnum } from './member-role.enum';
import { subEnum } from './sub-enum.helper';

export const InviteRoleEnum = subEnum(MemberRoleEnum, [
  MemberRoleEnum.admin,
  MemberRoleEnum.member,
]);
export type InviteRoleEnum =
  (typeof InviteRoleEnum)[keyof typeof InviteRoleEnum];
